import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

const Supporters = () => {
  const logos = [
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745440818/image_1705_vgwgs5.png',

      link: 'https://www.getthola.com/',

    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745440818/image_1709_yxhpot.png',

      link: 'https://4-bm.africa/',
    },
    {
src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1622_n4is0p.png',
      link: 'https://foodsecurityconsortium.com/about-us/',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745440819/image_1710_p0ftfy.png',
      link: 'http://www.myhustle.africa',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744212807/image_1623_w0ewam.png',
      link: 'http://www.ahafrica.co.za',
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745440810/image_1711_f6ibwd.png',

      link: 'https://www.fedi.xyz/',

    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1745441018/image_1699_f2r8dk.png',
      link: '#', // Add actual link if available
    },
    {
      src: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744365159/1_ofoqvc.png',

      link: 'https://www.getthola.com/', // Add actual link if available
    },
  ];

  return (
    <div className="md:my-1 my-3 md:mt-10 ">
      <h1 className='md:text-[36px] md:flex hidden text-[#FDBD26] font-bold md:mb-2 mb-2 tracking-wide'>
      PARTNERS
      </h1>
      <h1 className='text-[16px] md:hidden flex text-[#FDBD26] font-bold md:mb-0 mb-6'>

          Partners
        
      

      </h1>
      <div className=''>
        <Swiper
         slidesPerView={7.4}
                 spaceBetween={0}
                 loop={true}
                 autoplay={{
                   delay: 2000,
                   disableOnInteraction: false,
                 }}
                 modules={[Autoplay]}
                 breakpoints={{
                   320: { slidesPerView: 5.2, spaceBetween: 10 },
                   640: { slidesPerView: 5.2, spaceBetween: 10 },
                   1024: { slidesPerView: 5.6, spaceBetween: 20 },
                 }}
        >
          {logos.map((logo, idx) => (
            <SwiperSlide key={idx} className="flex justify-center items-center mb-5">
  <a href={logo.link} target="_blank" rel="noopener noreferrer">
    <img
      src={logo.src}
      alt={`Logo ${idx + 1}`}
      className="md:h-[98px] w-auto object-contain"
    />
  </a>
</SwiperSlide>

          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Supporters;
